import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    menus: []
};

const menuSlice = createSlice({
    name: 'menu',
    initialState,
    reducers: {
        updateMenus: (state, action) => {
            const data = action.payload;
            state.menus = data;
        }
    }
});

export const { updateMenus } = menuSlice.actions;
export const menuSelector = state => state.menu;

export default menuSlice.reducer;
